import {
    IconButton,
    InputAdornment,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from '@mui/material';
import { SearchSvgIcon } from 'src/pages/ProjectsPage/icons/SearchIcon';
import { ts } from 'src/utils/translate';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { ProjectsDisplayMode, projectsUiSlice } from 'src/api/projects-ui-slice';
import React, { ChangeEvent, MouseEvent, useState } from 'react';
import { GridIcon } from 'src/pages/ProjectsPage/icons/GridIcon';
import { ListSvgIcon } from 'src/pages/ProjectsPage/icons/ListIcon';
import { DEFAULT_SPACING } from 'src/theme/style-consts';
import { CalendarIcon } from "src/pages/ProjectsPage/icons/CalendarIcon";
import { DateRangePickerView } from "src/pages/ProjectsPage/DateRangePickerView";
import { theme } from "src/theme/mui-theme";

export function ProjectsPageHeader() {
  const dispatch = useAppDispatch();

  const projectsUiState = useAppSelector((state) => state.projectsUi);

  function onSearchTextChange(event: ChangeEvent<HTMLInputElement>) {
    dispatch(projectsUiSlice.actions.setSearchText(event.target.value));
  }

  function onDisplayModeChange(_: MouseEvent<HTMLElement>, newValue: ProjectsDisplayMode) {
    if (newValue != null) {
      dispatch(projectsUiSlice.actions.setDisplayMode(newValue));
    }
  }

  const [dateRangePickerViewAnchorEl, setDateRangePickerViewAnchorEl] = useState<null | HTMLElement>(null);

  const handleDateRangePickerClick = (event: React.MouseEvent<HTMLElement>) => {
      setDateRangePickerViewAnchorEl(event.currentTarget);
  };

  return (
      <>
        <Stack direction="row" alignItems="center" spacing={DEFAULT_SPACING} sx={{ width: '100%', justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: '35px', fontWeight: 600 }}>
            {ts('project_title', 'Projects')}
          </Typography>

            <TextField
                value={projectsUiState.searchText}
                label={ts('projects_search', 'Search')}
                size="small"
                sx={{ width: '40%' }}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchSvgIcon />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    edge="end"
                                    onClick={handleDateRangePickerClick}
                                    sx={{
                                        color:
                                            projectsUiState.startDate && projectsUiState.endDate
                                                ? theme.palette.primary.main
                                                : theme.palette.text.secondary
                                    }}
                                >
                                    <CalendarIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    },
                }}
                variant="outlined"
                onChange={onSearchTextChange}
            />

            <Stack direction="row" spacing={DEFAULT_SPACING} alignItems="center">
            <ToggleButtonGroup
                size="small"
                value={projectsUiState.displayMode}
                exclusive
                onChange={onDisplayModeChange}
            >
              <ToggleButton value="grid">
                <GridIcon />
              </ToggleButton>
              <ToggleButton value="list">
                <ListSvgIcon />
              </ToggleButton>
            </ToggleButtonGroup>

            <DateRangePickerView anchorEl={dateRangePickerViewAnchorEl} handleClose={() => setDateRangePickerViewAnchorEl(null)}/>
          </Stack>
        </Stack>
      </>
  )
}